import { ReactNode } from "react";

import { Container } from "@mui/material";

import { Background } from "@baseComponents/Background";
import Footer from "@components/footer";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

interface ProjectsLayoutProps extends PageMetadataProps {
  children?: ReactNode;
}

function ProjectsLayoutBody({
  children,
  title,
  description,
}: ProjectsLayoutProps) {
  return (
    <>
      <PageMetadata title={title} description={description} />

      <Background />

      <Menu />

      <Container maxWidth="desktopXl" className="p-0">
        {children}
      </Container>

      <Footer />
    </>
  );
}

export const ProjectsLayout = ({ children, ...rest }: ProjectsLayoutProps) => {
  return <ProjectsLayoutBody {...rest}>{children}</ProjectsLayoutBody>;
};
